'use client';

import { useEffect } from 'react';

export type CssVarName = `--${string}`;

export function useCssVar(
    name: CssVarName,
    value: number | string | null,
): void {
    useEffect(() => {
        if (typeof document === 'undefined') {
            return;
        }

        const root = document.documentElement;

        if (value === null) {
            root.style.removeProperty(name);
            return;
        }

        const cssValue =
            typeof value === 'number'
                ? `${value}px`
                : value;

        root.style.setProperty(name, cssValue);

        return () => {
            root.style.removeProperty(name);
        };
    }, [name, value]);
}